import { useTranslation } from "react-i18next";

import BaseModal from "@/components_v2/Modal/BaseModal";
import BaseButton from "@/components_v2/Button/BaseButton";
import {
  BUTTON_SIZES,
  BUTTON_VARIANTS,
} from "@/components_v2/Button/constants";
import { OrganizationUserPermissionsModalProps } from "../types";

const OrganizationUserPermissionsModal = ({
  open,
  onCancel,
}: OrganizationUserPermissionsModalProps) => {
  const { t } = useTranslation();

  return (
    <BaseModal
      open={open}
      title={t("auth.labels.organizationUserPermission")}
      onCancel={onCancel}
      width={1000}
      footer={
        <BaseButton
          size={BUTTON_SIZES.SMALL}
          variant={BUTTON_VARIANTS.TERTIARY}
          onClick={onCancel}
        >
          {t("auth.labels.close")}
        </BaseButton>
      }
    >
      <div>
        <table className="prme-permissions">
          <thead>
            <tr>
              <th className="prme-perms-header" style={{ width: "150px" }}>
                {t("auth.labels.typeOfTerm")}
              </th>
              <th className="prme-perms-header" style={{ width: "200px " }}>
                {t("auth.labels.term")}
              </th>
              <th className="prme-perms-header">
                {t("auth.labels.definition")}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="row-term">
                {t("auth.labels.institutionalAccountTerm")}
              </td>
              <td className="row-definition">
                {t("auth.labels.institutionalAccountDefinition")}
              </td>
            </tr>
            <tr>
              <td className="row-term">{t("auth.labels.supervisorTerm")}</td>
              <td className="row-definition">
                {t("auth.labels.supervisorDefinition")}
              </td>
            </tr>
            <tr>
              <td className="row-term">{t("auth.labels.memberTerm")}</td>
              <td className="row-definition">
                {t("auth.labels.memberDefinition")}
              </td>
            </tr>
            <tr>
              <td className="row-type" rowSpan={3}>
                {t("auth.labels.sharingRights")}*
              </td>
              <td className="row-term">{t("auth.labels.public")}</td>
              <td className="row-definition">
                {t("auth.labels.publicDescription")}
              </td>
            </tr>
            <tr>
              <td className="row-term">{t("auth.labels.private")}</td>
              <td className="row-definition">
                {t("auth.labels.privateDescription")}
              </td>
            </tr>
            <tr>
              <td className="row-term">{t("auth.labels.prmeCommunity")}</td>
              <td className="row-definition">
                {t("auth.labels.prmeCommunityDescription")}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </BaseModal>
  );
};

export default OrganizationUserPermissionsModal;
